// extracted by mini-css-extract-plugin
export default {"ljiRed":"#ee2346","ended":"ExtracurricularList_ended__GHNsB","noExtracurriculars":"ExtracurricularList_noExtracurriculars__TNVBA","editLink":"ExtracurricularList_editLink__AA6rK"};